(function ($) {
  'use strict';

  this.CyclingTrips.Detail = function () {
    this.resizeTimeout = null;

    this.$embed = $('.temp-copy');

    this.initialize();
    this.niceScrollbar();
    this.weather();
    this.back();
    this.reviewContent();

    /*
     * Hook fired when the window resizes
     */
    this.resized = function () {
      // Timeout for resizing the window, so we do not reinitialize this several times at once
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      var t = this;
      this.resizeTimeout = setTimeout(function () {
        t.initialize();
      }, 250);
    };

    /*
     * Toggle the itinerary
     */
    this.toggleItinerary = function (e) {
      var $button = $(e.currentTarget);
      $button.toggleClass('show');

      // switch the svg arrow
      if ($button.hasClass('show')) {
        $button.find('svg').addClass('up').removeClass('down');
      } else {
        $button.find('svg').addClass('down').removeClass('up');
      }

      // Show all hidden elements, maintain flex display
      var $elements = $button.prev('ol').find('.hidden');
      if ($button.hasClass('show')) {
        $elements.slideDown({
          start: function () {
            $(this).css({ display: 'flex' });
          },
          progress: function () {
            $(document).trigger('CyclingTrips:updateMapPosition');
          },
        });
      } else {
        $elements.slideUp({
          progress: function () {
            $(document).trigger('CyclingTrips:updateMapPosition');
          },
        });
      }
    };

    /*
     * Show the summary, it will not be hidden again
     */
    this.showSummary = function (e) {
      var $button = $(e.currentTarget);
      $button.slideUp();
      var $content = $button.closest('.entry-content').find('.content');
      $content
        .height($content.height())
        .css('max-height', 'none')
        .addClass('shown');
      $content.animate(
        {
          height: $content.get(0).scrollHeight,
        },
        {
          duration: 500,
          progress: function () {
            $(document).trigger('CyclingTrips:updateMapPosition');
          },
          complete: function () {
            $content.height('auto');
            $content.parent().removeClass('show-button');
            $(document).trigger('CyclingTrips:updateMapPosition');
          },
        }
      );
    };

    this.embed = function (e) {
      e.preventDefault();
      if (this.$embed.is(':visible')) {
        this.hideEmbed();
      } else {
        this.$embed.slideDown({
          start: function () {
            $(this).css({ display: 'flex' });
          },
          progress: function () {
            $(document).trigger('CyclingTrips:updateMapPosition');
          },
        });
        $('#permalink').focus().select();
      }
    };

    // Register events
    $(document).on(
      'click',
      '.itinerary .show-more',
      this.toggleItinerary.bind(this)
    );
    $(document).on(
      'click',
      '.entry-content .show-more',
      this.showSummary.bind(this)
    );
    $(document).on('click', '.share .embed', this.embed.bind(this));
    $(document).on('click', '.temp-copy .copy', this.copyPermalink.bind(this));
    $(document).on('click', '.share > a', this.share.bind(this));
    $(document).on('CyclingTrips:mapSectionReorder', this.elevation.bind(this));
  };

  /*
   * Initialize the content, decide whether to show the "show more button"
   */
  this.CyclingTrips.Detail.prototype.initialize = function () {
    var $content = $('.entry-content .content:not(.shown)');
    if ($content.length) {
      if ($content.get(0).scrollHeight > $content.height()) {
        $content.parent().addClass('show-button');
      } else {
        $content.parent().removeClass('show-button');
      }
    }

    function checkIfMapLoaded() {
      setTimeout(function () {
        if (typeof map === 'undefined') {
          checkIfMapLoaded();
        } else {
          this.CyclingTrips.Detail.prototype.mapLoaded();
        }
      }, 1000);
    }

    checkIfMapLoaded();
  };

  this.CyclingTrips.Detail.prototype.mapLoaded = function () {
    var mapIdleTimeout = null;
    google.maps.event.addListener(map, 'idle', function () {
      if (mapIdleTimeout === null) {
        google.maps.event.trigger(map, 'idle_start');
      }
      clearTimeout(mapIdleTimeout);
      mapIdleTimeout = setTimeout(function () {
        google.maps.event.trigger(map, 'idle_end');
        mapIdleTimeout = null;
      }, 50);
    });

    this.itinerary();
    this.elevation();
    this.milestones();
    //set map controlls
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(
      CyclingTrips.prototype.getZoomControl(map)[0]
    );

    //set center controlls
    map.controls[google.maps.ControlPosition.LEFT_TOP].push(
      CyclingTrips.prototype.getCenterControl(map)[0]
    );

    ys.markers = [];
    var zIndex = 1000;

    //set stop points
    $('.map-stop-marker').each(function () {
      zIndex += 10;
      var t = $(this);
      var lat = parseFloat(t.attr('data-lat'));
      var lng = parseFloat(t.attr('data-lng'));
      var markerImage = {
        url: window.ys.cycling_trips.icons.stop,
        scaledSize: new google.maps.Size(38, 44),
      };
      var marker = new google.maps.Marker({
        position: {
          lat: lat,
          lng: lng,
        },
        clickable: false,
        zIndex: zIndex,
        icon: markerImage,
        optimized: false,
        map: map,
      });
      ys.markers.push(marker);
    });

    //set start points
    $('.map-start-marker').each(function () {
      zIndex += 10;
      var t = $(this);
      var lat = parseFloat(t.attr('data-lat'));
      var lng = parseFloat(t.attr('data-lng'));
      var markerImage = {
        url: window.ys.cycling_trips.icons.start,
        scaledSize: new google.maps.Size(38, 44),
      };
      var marker = new google.maps.Marker({
        position: {
          lat: lat,
          lng: lng,
        },
        clickable: false,
        zIndex: zIndex,
        icon: markerImage,
        optimized: false,
        map: map,
      });
      ys.markers.push(marker);
    });

    //set map center to first itinerary if there is no kml
    if (
      $('.map-start-marker').length === 0 &&
      $('.map-stop-marker').length === 0 &&
      $('.itinerary .poi').length > 0
    ) {
      var bounds = new google.maps.LatLngBounds();
      $('.itinerary .poi').each(function (i) {
        if (i === 0) {
          $(this).trigger('click');
        }
        var lat = parseFloat($(this).attr('data-lat'));
        var lng = parseFloat($(this).attr('data-lng'));
        bounds.extend({ lat: lat, lng: lng });
      });
      map.fitBounds(bounds);
    }

    map.addListener('zoom_changed', function () {
      for (var i = 0; i < ys.markers.length; i++) {
        ys.markers[i].setMap(map);
      }
    });
  };

  this.CyclingTrips.Detail.prototype.hideEmbed = function () {
    this.$embed.slideUp({
      progress: function () {
        $(document).trigger('CyclingTrips:updateMapPosition');
      },
    });
  };

  this.CyclingTrips.Detail.prototype.copyPermalink = function (e) {
    var clipboard = new WLCClipboard($('#permalink'));
    if (clipboard.copy()) {
      this.hideEmbed();
    }
  };

  this.CyclingTrips.Detail.prototype.niceScrollbar = function () {
    $('.nice-scrollbar').each(function () {
      $(this).jScrollPane({
        verticalDragMinHeight: 16,
        verticalDragMaxHeight: 16,
        horizontalDragMinWidth: 16,
        horizontalDragMaxWidth: 16,
      });
      var api = $(this).data('jsp');
      var throttleTimeout;
      $(window).bind('resize', function () {
        if (!throttleTimeout) {
          throttleTimeout = setTimeout(function () {
            api.reinitialise();
            throttleTimeout = null;
          }, 500);
        }
      });
    });
  };

  this.CyclingTrips.Detail.prototype.weather = function () {
    var days = jQuery('.weather-forecast .days');
    days.hide();
    var label = jQuery('.weather-forecast .show-more');
    var icon = label.find('svg.font-icon');
    label.click(function (e) {
      e.preventDefault();
      days.slideToggle();
      if (icon.hasClass('down')) {
        icon.removeClass('down');
        icon.addClass('up');
      } else {
        icon.removeClass('up');
        icon.addClass('down');
      }
    });
  };

  this.CyclingTrips.Detail.prototype.elevation = function () {
    var markerImage = {
      url: window.ys.cycling_trips.icons.basic,
      scaledSize: new google.maps.Size(35, 35),
    };

    var marker = new google.maps.Marker({
      icon: markerImage,
      optimized: false,
      zIndex: 1000,
      map: null,
    });

    function showCurrentMarker(latLng) {
      //marker.setMap(map);
      if (!marker.getMap()) {
        marker.setMap(map);
      }
      marker.setPosition({ lat: latLng.lat, lng: latLng.lng });
    }

    function hideCurrentMarker() {
      marker.setMap(null);
    }

    function getAverageElevation(rawData, index) {
      var delta = 5;
      var count = 0;
      var sum = 0;
      for (var i = -delta; i <= delta; i++) {
        count++;
        sum += rawData[index + i]
          ? rawData[index + i].elevation
          : rawData[index].elevation;
      }
      return sum / count;
    }

    var dataId = 0;
    $('.elevation-chart').each(function () {
      var t = $(this);
      var rawElevation = elevation[dataId];
      var distance = elevation_distance[dataId];
      var chartElevation = [];
      var chartLatLng = [];
      var dataFactor = 1;
      var tickInterval = 1;

      t.click(function () {
        if (marker.getMap()) {
          map.setCenter(marker.getPosition());
        }
      });

      var highchart = $(this).data('highchart');
      if (highchart) {
        highchart.destroy();
      }

      if (distance > 10) {
        tickInterval = Math.ceil(distance / 9 / 5) * 5; //appriximately 9 ticks on X axis
      }

      var interval = distance / (rawElevation.length / dataFactor);

      for (var i = 0; i < rawElevation.length; i = i + dataFactor) {
        chartElevation.push(getAverageElevation(rawElevation, i));
        chartLatLng.push(rawElevation[i].location);
      }
      var id = t.attr('id');
      var min = Math.min.apply(null, chartElevation);
      var max = Math.max.apply(null, chartElevation);
      var floor = min - Math.abs(max - min) * 0.1;

      highchart = Highcharts.chart(id, {
        chart: {
          type: 'areaspline',
          height: 200,
          marginRight: 0,
        },
        title: {
          text: false,
        },
        subtitle: {
          text: false,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          allowDecimals: false,
          gridLineWidth: 1,
          tickWidth: 1,
          tickInterval: tickInterval,
          showLastLabel: false,
          title: {
            text: 'km',
            align: 'high',
            reserveSpace: false,
            y: -15,
            x: -8,
            style: {
              color: '#1d6b0c',
              'font-weight': 'bold',
            },
          },
          labels: {
            style: {
              color: '#1d6b0c',
              'font-weight': 'bold',
            },
            y: 25,
          },
          plotBands: [
            {
              from: 0,
              to: 500,
              color: '#f9f9f9',
            },
          ],
          crosshair: {
            width: 1,
            color: 'gold',
            zIndex: 4,
          },
        },
        yAxis: {
          floor: floor,
          showLastLabel: false,
          title: {
            text: 'hm',
            align: 'high',
            reserveSpace: false,
            rotation: 0,
            y: 5,
            x: 23,
            style: {
              color: '#1d6b0c',
              'font-weight': 'bold',
            },
          },
          labels: {
            style: {
              color: '#1d6b0c',
              'font-weight': 'bold',
            },
          },
        },
        tooltip: {
          headerFormat: '',
          formatter: function () {
            var y = this.y.toFixed(2);
            var index = this.point.index;
            showCurrentMarker(chartLatLng[index]);
            return '<b>' + y + '</b>m';
          },
        },
        plotOptions: {
          series: {
            lineColor: 'rgba(14, 58, 47, 1)',
          },
          areaspline: {
            events: {
              mouseOut: function () {
                hideCurrentMarker();
              },
            },
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: false,
                },
              },
            },
            pointInterval: interval,
          },
        },
        series: [
          {
            color: 'rgba(120, 250, 174, 1)',
            fillOpacity: 1,
            data: chartElevation,
          },
        ],
      });

      $(this).data('highChart', highchart);
      jQuery('.highcharts-plot-band').click();
      dataId++;
    });
  };

  this.CyclingTrips.Detail.prototype.itinerary = function () {
    var markerImage = {
      url: window.ys.cycling_trips.icons.basic,
      scaledSize: new google.maps.Size(35, 35),
    };

    var marker = new google.maps.Marker({
      icon: markerImage,
      optimized: false,
      zIndex: 1000,
      map: null,
    });

    jQuery('.itinerary li.poi').click(function () {
      var t = jQuery(this);
      if (t.hasClass('selected')) {
        t.removeClass('selected');
        marker.setMap(null);
      } else {
        jQuery('.itinerary li.poi').removeClass('selected');
        var lat = parseFloat(t.attr('data-lat'));
        var lng = parseFloat(t.attr('data-lng'));
        t.addClass('selected');
        marker.setMap(null);
        marker.setAnimation(google.maps.Animation.DROP);
        marker.setPosition({ lat: lat, lng: lng });
        marker.setMap(map);
      }
    });
  };

  this.CyclingTrips.Detail.prototype.milestones = function () {
    var overlay = new google.maps.OverlayView();
    overlay.draw = function () {};
    overlay.setMap(map);

    var milestonesInZoom = {
      //zoomLevel: divider
      21: 5,
      20: 5,
      19: 5,
      18: 5,
      17: 5,
      16: 5,
      15: 5,
      14: 5,
      13: 5,
      12: 5,
      11: 10,
      10: 15,
      9: 25,
      8: 60,
      7: 200,
      6: 0,
      5: 0,
      4: 0,
      3: 0,
      2: 0,
      1: 0,
    };

    function waitUntillOverlayDefined() {
      if (
        typeof overlay.getProjection === 'function' &&
        overlay.getProjection()
      ) {
        overlayDefined();
      } else {
        setTimeout(waitUntillOverlayDefined, 200);
      }
    }

    waitUntillOverlayDefined();

    function overlayDefined() {
      var panes = overlay.getPanes();
      if (kml_milestones) {
        for (var i = 0; i < kml_milestones.length; i++) {
          var xy = overlay
            .getProjection()
            .fromLatLngToDivPixel(
              new google.maps.LatLng(
                kml_milestones[i].lat,
                kml_milestones[i].lng
              )
            );
          panes.markerLayer.appendChild(
            jQuery(
              '<div class="kml-milestone" data-lat="' +
                kml_milestones[i].lat +
                '" data-lng="' +
                kml_milestones[i].lng +
                '" style="top:' +
                xy.y +
                'px;left:' +
                xy.x +
                'px;">' +
                '<div class="kml-milestone-content">' +
                kml_milestones[i].distance +
                '</div>' +
                '</div>'
            )[0]
          );
        }
      }
      recalculate();
    }

    function recalculate() {
      var milestones = jQuery('.kml-milestone');
      var currentZoomLevel = map.getZoom();
      milestones.each(function () {
        var milestone = jQuery(this);
        var lat = milestone.attr('data-lat');
        var lng = milestone.attr('data-lng');
        var val = parseInt(milestone.find('.kml-milestone-content').html());
        if (
          milestonesInZoom[currentZoomLevel] &&
          milestonesInZoom[currentZoomLevel] !== 0 &&
          val % milestonesInZoom[currentZoomLevel] === 0
        ) {
          milestone.removeClass('hidden');
        } else {
          milestone.addClass('hidden');
        }
        var xy = overlay
          .getProjection()
          .fromLatLngToDivPixel(
            new google.maps.LatLng(parseFloat(lat), parseFloat(lng))
          );
        milestone.css({ top: xy.y + 'px', left: xy.x + 'px' });
      });
    }

    google.maps.event.addListener(map, 'idle_start', function () {
      jQuery('.kml-milestone').addClass('hidden');
    });

    google.maps.event.addListener(map, 'idle_end', function () {
      recalculate();
    });
  };

  this.CyclingTrips.Detail.prototype.back = function () {
    $(document).on('click', '.back', function (e) {
      e.preventDefault();
      var t = jQuery(this);
      var url = Cookies.get('cycling_trips_last_archive_url');
      if (url) {
        window.location.href = url;
      } else {
        window.location.href = t.attr('href');
      }
    });
  };

  this.CyclingTrips.Detail.prototype.reviewContent = function () {
    $('.entry-content a').each(function () {
      var t = $(this);
      t.attr('target', '_blank');
    });
  };

  this.CyclingTrips.Detail.prototype.share = function (e) {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'gaEvent',
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: e.currentTarget.className,
      });
    }
  };
}).bind(window)(jQuery);
